import { FormGroup } from 'reactstrap'
import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Checkboxes from '../../components/Study/Checkboxes.jsx'

class Questions extends React.Component {
    render() {
        // const { t } = this.props
        return (
            <div className="question-wrapper">
                <div className={`label md-font-size ${this.props.color}`}>{this.props.title}</div>
                <div className="checkboxes">
                    <FormGroup tag="fieldset">
                        <Checkboxes
                            options={this.props.options}
                            questionId={this.props.questionId}
                            questionMultichoice={this.props.questionMultichoice}
                            props={this.props}
                        />
                    </FormGroup>
                </div>
            </div >

        )
    }
}

Questions.propTypes = {
    t: PropTypes.func,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    title: PropTypes.string,
    options: PropTypes.array,
    questionId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    color: PropTypes.string,
}

export default withTranslation()(Questions)



// WEBPACK FOOTER //
// ./src/components/Study/Questions.jsx